export const ME_GET_REQUESTING = 'ME_GET_REQUESTING';
export const ME_GET_SUCCESS = 'ME_GET_SUCCESS';
export const ME_GET_ERROR = 'ME_GET_ERROR';